import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { listTargets, NotificationTarget, upsertTarget } from "../api";

const CHANNELS = ["EMAIL", "SMS", "WHATSAPP", "PANEL"] as const;

export function TargetsPage() {
  const { t } = useTranslation(["dashboard", "common"]);
  const [targets, setTargets] = useState<NotificationTarget[]>([]);
  const [firmId, setFirmId] = useState("");
  const [channel, setChannel] = useState<(typeof CHANNELS)[number]>("EMAIL");
  const [destination, setDestination] = useState("");
  const [error, setError] = useState<string | null>(null);

  async function refresh() {
    try {
      const list = await listTargets();
      setTargets(list);
      setError(null);
    } catch (exc) {
      setError(String(exc));
    }
  }

  useEffect(() => {
    refresh();
  }, []);

  async function onAdd(event: React.FormEvent) {
    event.preventDefault();
    try {
      await upsertTarget(firmId, channel, destination);
      setDestination("");
      refresh();
    } catch (exc) {
      setError(String(exc));
    }
  }

  return (
    <div className="targets">
      <h2>{t("targets.title")}</h2>
      {error && <p className="error">{error}</p>}
      <form onSubmit={onAdd} className="add-target">
        <input
          placeholder={t("targets.firmPlaceholder")}
          value={firmId}
          onChange={(e) => setFirmId(e.target.value)}
          required
        />
        <select value={channel} onChange={(e) => setChannel(e.target.value as typeof channel)}>
          {CHANNELS.map((c) => (
            <option key={c} value={c}>
              {c}
            </option>
          ))}
        </select>
        <input
          placeholder={t("targets.destinationPlaceholder")}
          value={destination}
          onChange={(e) => setDestination(e.target.value)}
          required
        />
        <button type="submit">{t("common:actions.add")}</button>
      </form>

      <table>
        <thead>
          <tr>
            <th>{t("targets.th.firm")}</th>
            <th>{t("targets.th.channel")}</th>
            <th>{t("targets.th.destination")}</th>
            <th>{t("targets.th.active")}</th>
          </tr>
        </thead>
        <tbody>
          {targets.map((tg) => (
            <tr key={tg.id}>
              <td>{tg.firm_id}</td>
              <td>{tg.channel}</td>
              <td>{tg.destination}</td>
              <td>{tg.active ? t("common:bool.yes") : t("common:bool.no")}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
